import { ID, Guardian, Law } from "@airhelp/icons";
import type { SbEditableComponentProps } from "types/storyblok";
import iconSizes from "./Icon.config";
import type { IconProps } from "./Icon.d";

const icons = {
  HammerIcon: Law,
  GuardianIcon: Guardian,
  ID,
};

const Icon = ({ name, color, size, sbEditable }: SbEditableComponentProps<IconProps>) => {
  const IconComponent = icons[name];
  return <IconComponent boxSize={iconSizes[size]} color={color} {...sbEditable} />;
};

export default Icon;
